import { render, staticRenderFns } from "./FinishStationYearlyOtchet.vue?vue&type=template&id=aff0c81e"
import script from "./FinishStationYearlyOtchet.vue?vue&type=script&lang=js"
export * from "./FinishStationYearlyOtchet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports